import {
  TableBody,
  TableCell,
  TableRow,
} from '@cambridgeassessment/cambridge-ui';
import React, { memo } from 'react';
import Loader from 'src/components/Loader/Loader';

type TableLoaderProps = {
  colSpan: number;
};

const TableLoader: React.FC<TableLoaderProps> = ({ colSpan }) => {
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={colSpan}>
          <Loader height={200} />
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

export default memo(TableLoader);
